

function isEmail(string: string) {
	const re =
		/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
	return re.test(string);
}

export function emailV(value: string) {
	return value && !isEmail(value.trim()) ? 'Invalid email address' : null;
}

function isPassword(string: string) {
	const passwordString = string.trim().length > 8;
	return passwordString;
}

function isConfirmPassword(string: string) {
	const confirmPasswordString = string.trim().length > 8;
	return confirmPasswordString;
}

export function passwordValidate(value: string) {
	return value && !isPassword(value.trim())
		? 'Password must be more than 8 characters'
		: null;
}

export function confirmPassword(value: string) {
	return value && !isConfirmPassword(value.trim())
		? 'Password must be more than 8 characters'
		: null;
}

function isDirty(value: string | number) {
	return value || value === 0;
}

export function required(
	requiredFields: readonly string[],
	values: Record<string, string>
  ): Record<string, string> {
	return requiredFields.reduce(
	  (fields, field) => ({
		...fields,
		...(isDirty(values[field]) ? {} : { [field]: 'Required' }),
	  }),
	  {},
	);
  }